import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useSelector} from 'react-redux';

const PublicRoute = () => {
  const isLoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const isAuthenticated = isLoggedIn || localStorage.getItem('token');
  console.log("pb_r");
  console.log(isAuthenticated);
  return isAuthenticated ? <Navigate to="/trip-make" /> : <Outlet />;
};

export default PublicRoute;
